import { render, staticRenderFns } from "./AlvoradaSexo.vue?vue&type=template&id=0fe733f8&scoped=true"
import script from "./AlvoradaSexo.vue?vue&type=script&lang=ts"
export * from "./AlvoradaSexo.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaSexo.vue?vue&type=style&index=0&id=0fe733f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe733f8",
  null
  
)

export default component.exports